export default {"src":"/_next/static/media/github_icon.32a10083.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};